function Image(slide, url) {

  slide.style.backgroundImage = "url(" + url + ")";

}

module.exports = Image;



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/modules/image.js